import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { FormValidationService } from './../../../../../services/form-validation.service';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { NotificationService } from 'app/services';
import { ActivatedRoute } from '@angular/router';
import { emailValidates } from '../../../../../services/validator';


@Component({
  selector: 'app-student-contact-email',
  templateUrl: './student-contact-email.component.html',
  styleUrls: ['./student-contact-email.component.scss']
})
export class StudentContactEmailComponent implements OnChanges, OnDestroy {
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  EMAIL_VALIDATORS = Validators.compose([Validators.required, Validators.pattern(this.emailPattern)]);

  @Input() userEmailData: any;
  @Output() emailUpdates: EventEmitter<any> = new EventEmitter<any>();
  emailForm: FormGroup;
  backendUpdate = false;
  addEmailAddress: string;
  additionalEmailUpdate: Subscription;
  emailChangeCount = 0;
  private destroyed$ = new Subject();

  constructor(
    private formBuilder: FormBuilder,
    private _commonDataSharedService: CommonDataSharedService,
    private _formValidationService: FormValidationService,
    private notificationService: NotificationService,
    private routes: ActivatedRoute
  ) {
    this.additionalEmailUpdate = this._commonDataSharedService.saveEmailPhone.subscribe(() => {
      if (this.addEmailAddress) {
        this.emailForm.value.additionalEmails.push({
          id: null,
          emailAddresses: this.addEmailAddress,
          preferred: false
        })
        this.updateEmails(this.emailForm.value, 'onLoad');
      }
    })
    this.buildForm();

    this._formValidationService.touchForms
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.emailForm.markAsTouched();
        (<any>Object).values(this.emailForm.controls).forEach((control: FormControl) => {
          control.markAsTouched();
        });
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.additionalEmailUpdate.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['userEmailData'] !== undefined && changes['userEmailData'].currentValue !== undefined) {
      this.backendUpdate = true;
      this.hydrateForm(changes['userEmailData'].currentValue);
      this.backendUpdate = false;
    }
  }


  buildForm() {
    this.emailForm = this.formBuilder.group({
      primaryEmail: ['', this.EMAIL_VALIDATORS],
      addEmailControl: ['', Validators.compose([(control) => control.value ? Validators.pattern(this.emailPattern)(control) : null])],  // empty value should pass validation
      primaryEmailId: 0,
      additionalEmails: this.formBuilder.array([])
    }, { validator: emailValidates }
    );

    this.emailForm.valueChanges
      .filter(() => !this.backendUpdate)
      .pipe(debounceTime(10), takeUntil(this.destroyed$))
      .subscribe(newEmail => this.updateEmails(newEmail, 'onChange'));
    this._formValidationService.registerForm('emailForm', this.emailForm);
  }

  hydrateForm(newData) {
    newData = newData || {};
    newData.email = newData.email || [];

    const preferredEmail = newData.email.filter(item => item.preferred)[0] || newData.email[0] || {
      emailAddresses: '',
      preferred: true
    };

    const values = {
      primaryEmail: preferredEmail.emailAddresses,
      primaryEmailId: preferredEmail.id,
      additionalEmails: newData.email ? newData.email.filter(item => item !== preferredEmail).map(function (item) {
        return { emailAddresses: item.emailAddresses, id: item.id }
      }) : []
    };
    this.emailForm.get('additionalEmails')['controls'] = [];
    this.emailForm.patchValue(values);
    // loop through the additional emails and add them to the instance of our additionalEmails form array so they will be shown in the UI by default
    if (values.additionalEmails.length > 0) {
      values.additionalEmails.map(address => {
        const control = <FormArray>this.emailForm.get('additionalEmails');
        control.push(this.formBuilder.group({
          id: null,
          emailAddresses: [address.emailAddresses, this.EMAIL_VALIDATORS],
          preferred: false
        }));
        this.emailForm.get('addEmailControl').setValue('');
      });
    }
  }

  addEmail(emailAddress) {
    const control = <FormArray>this.emailForm.get('additionalEmails');
    if (emailAddress) {
      if (!this.emailForm.value.additionalEmails.map(data => data.emailAddresses).includes(emailAddress) && this.emailForm.value.primaryEmail !== emailAddress) {
        control.push(this.formBuilder.group({
          id: null,
          emailAddresses: [emailAddress, this.EMAIL_VALIDATORS],
          preferred: false
        }));
        this._commonDataSharedService.duplicateContact.next(true);
      } else {
        this.notificationService.show('error', 'Email is already added');
      }
    }


    control.markAsDirty();
    this.emailForm.get('addEmailControl').setValue('');
  }

  removeEmail(i: number) {
    const control = <FormArray>this.emailForm.controls['additionalEmails'];
    control.removeAt(i);
    control.markAsDirty();
  }

  updateEmails(values, change) {
    if (change === 'onChange') {
      this.emailChangeCount = this.emailChangeCount + 1;
      if (this.emailForm && this.emailChangeCount > 1) {
        const currentRoute = this.routes.snapshot.url[0].path;
        this._commonDataSharedService.saveModal.next(currentRoute);
        this._commonDataSharedService.duplicateContact.next(true);
        const emails = values.primaryEmail ?
          [{
            id: values.primaryEmailId || null,
            emailAddresses: values.primaryEmail,
            preferred: true
          }].concat(values.additionalEmails) :
          values.additionalEmails;
          
          
          this.emailUpdates.emit({
          email: emails,
          valid: this.emailForm.valid ? true : false
        });
      }
    }
  }
}
